import angular from 'angular';
import EndOfGameWidgetComponent from './end-of-game-component';

export default angular.module('end-of-game-widget', []).component('endOfGameWidget', new EndOfGameWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/end-of-game/end-of-game-widget-module.js